import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { FeatureSimpleView } from 'domains/Feature/components'

const FeatureList = (props) => {
  const { features, isListWithCreate, listView, emptyProps, actions } = props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {features?.length > 0 ? (
        features?.map((feature, index) => (
          <Col
            mb={4}
            key={feature?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <FeatureSimpleView
              actions={actions}
              index={index}
              isSelected={feature?._id === selectedItem}
              onSelect={setSelectedItem}
              feature={feature}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No features have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

FeatureList.propTypes = {
  features: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default FeatureList
